var _style, _defs, _rect, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    viewBox: "240 350 600 380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000005230360197653018040000006332616795351379588_);}\n\t.st1{fill:none;}\n\t.st2{font-family:'Lato-Semibold';}\n\t.st3{font-size:150px;}\n\t.st4{letter-spacing:-8;}\n\t.st5{font-family:'Lato-Heavy';}\n\t.st6{letter-spacing:-1.7;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 240,
    y: 350,
    width: 600,
    height: 380
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105422101155988409630000010289148847103145872_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000105422101155988409630000010289148847103145872_)"
    },
    d: "M719.4,489.9    c-4.8,0-9.6,0.3-14.3,0.9c-12.9-41.9-51.6-70.6-95.5-70.7c-10.9,0-21.8,1.8-32.1,5.4c-25.6-55.3-86.1-85.3-145.5-72.2    c-59.4,13.1-101.8,65.8-101.7,126.7c0,10.5,1.3,21,3.9,31.2c-56.6,8.6-97.1,59.4-92.9,116.5c4.2,57.1,51.7,101.4,109,101.7h369.1    c66.1,0,119.7-53.6,119.7-119.7S785.5,489.9,719.4,489.9L719.4,489.9z M719.4,709.4H350.2c-49.2,0.2-89.4-39.2-90.1-88.4    c-0.7-49.2,38.3-89.8,87.4-91c3.2-0.1,6.1-1.7,7.9-4.3c1.8-2.6,2.2-6,1.2-9c-19.8-56.7,9.7-118.7,66.1-139.2    c56.4-20.5,118.8,8.2,140,64.4c1,2.6,3,4.7,5.5,5.7c2.6,1.1,5.5,1,8-0.2c10.4-4.9,21.8-7.4,33.3-7.4c38,0.1,70.6,26.8,78.2,64    c1.1,5.4,6.4,8.9,11.8,7.8c6.5-1.3,13.1-2,19.8-2c55.1,0,99.8,44.7,99.8,99.8C819.2,664.7,774.5,709.4,719.4,709.4L719.4,709.4z     M719.4,709.4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 303.4,
    y: 519.1,
    className: "st1",
    width: 477,
    height: 148.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 410.6909 631.0732)",
    className: "st2 st3"
  }, "C")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 510.3643 631.0732)",
    className: "st2 st3 st4"
  }, "O")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.583 0 0 0.583 622.4883 681.0234)",
    className: "st5 st3 st6"
  }, "2")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.842579ede3c3e62a9cc4bb5f3fe604da.svg";
export { ForwardRef as ReactComponent };